import type { Maybe } from '@nova/core';

/**
 * Emitted on the event hub when socket.io automatically restores a dropped connection, so consumers
 * can refetch what they missed.
 */
export const WEBSOCKET_RECONNECTED_EVENT = 'websocket-reconnected';

/** Payload of {@link WEBSOCKET_RECONNECTED_EVENT}. */
export interface WebsocketReconnectedPayload {
  /** Attempts socket.io needed to reconnect (the Manager's `reconnect` argument). */
  attempts: number;
  /** How long the socket was down, or null when the drop itself was not observed. */
  disconnectedForMs: number | null;
  /** socket.io-client's reason for the drop, e.g. 'transport close' or 'ping timeout'. */
  disconnectReason: string | null;
}

/**
 * `SocketPlugin` debounces socket events by 100ms and forwards only the last payload, listing the
 * ids it swallowed under `debounce.ids`. One action can write several rows of the same entity in a
 * transaction — completing a move blocks every task that wanted its spot — so those events share a
 * window and all but one consumer sees an event carrying somebody else's id.
 */
export interface DebouncedSocketEvent {
  id?: Maybe<string>;
  debounce?: Maybe<{
    ids?: Maybe<Maybe<string>[]>;
  }>;
}
